import React from 'react';

interface Props {
  name: string;
}

const SuccessMessage = ({name}: Props) => (
  <div className="on-track-success-message" data-testid="on-track-success-message">
    <div className="on-track-success-message-content">
      <h1 className="on-track-success-message-header">Great Job {name}!</h1>
      <p className="on-track-success-message-text">You&apos;re now on track for the year.</p>
    </div>
  </div>
);

export default SuccessMessage;
